import {
  createFileRoute,
  lazyRouteComponent,
  stripSearchParams,
} from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import i18n from '~/utils/i18n';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { BetaBadge } from '~/ui/atoms/BetaBadge';

import { routeParams } from './-routeParams';
import { chatSearchDefaults, chatSearchSchema } from './-searchParams';
const title = i18n.t(($) => $.pageTitle, { ns: 'agentChat' });
export const Route = createFileRoute('/(main)/agent-chat/')({
  beforeLoad: createProtectedRoute({
    routePath: '/agent-chat/',
    ...routeParams,
  }),
  component: lazyRouteComponent(
    () => import('~/routes/(main)/agent-chat/-feature/AgentChatPage'),
    'AgentChatPage',
  ),
  head: () => getRouteHead(title),
  search: { middlewares: [stripSearchParams(chatSearchDefaults)] },
  staticData: { AppBar: { CustomComponent: BetaBadge, title } },
  validateSearch: chatSearchSchema,
});
export const AGENT_CHAT = buildRouteExport({ Route, ...routeParams });
